/* eslint-disable max-len */
import React, { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';
import { assertNever } from 'src/utils/assert';

type Props = {
  readonly mimeType: string;
};

export const AttachmentIcon = memo(({ mimeType }: Props) => {
  if (mimeType === 'application/pdf') {
    return (
      <IconWrapper>
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.5 0C10.7812 0 9.375 1.40625 9.375 3.125V46.875C9.375 48.5938 10.7812 50 12.5 50H43.75C45.4688 50 46.875 48.5938 46.875 46.875V12.5L34.375 0H12.5Z"
            fill="#E2E5E7"
          />
          <path
            d="M37.5 12.5H46.875L34.375 0V9.375C34.375 11.0938 35.7812 12.5 37.5 12.5Z"
            fill="#B0B7BD"
          />
          <path
            d="M46.875 21.875L37.5 12.5H46.875V21.875Z"
            fill="#CAD1D8"
          />
          <path
            d="M40.625 40.625C40.625 41.4844 39.9219 42.1875 39.0625 42.1875H4.6875C3.82812 42.1875 3.125 41.4844 3.125 40.625V25C3.125 24.1406 3.82812 23.4375 4.6875 23.4375H39.0625C39.9219 23.4375 40.625 24.1406 40.625 25V40.625Z"
            fill="#F15642"
          />
          <path
            d="M9.93604 29.6047C9.93604 29.1922 10.261 28.7422 10.7845 28.7422H13.6704C15.2954 28.7422 16.7579 29.8297 16.7579 31.9141C16.7579 33.8891 15.2954 34.9891 13.6704 34.9891H11.5845V36.6391C11.5845 37.1891 11.2345 37.5 10.7845 37.5C10.372 37.5 9.93604 37.1891 9.93604 36.6391V29.6047ZM11.5845 30.3156V33.4281H13.6704C14.5079 33.4281 15.1704 32.6891 15.1704 31.9141C15.1704 31.0406 14.5079 30.3156 13.6704 30.3156H11.5845Z"
            fill="white"
          />
          <path
            d="M19.2048 37.5001C18.7923 37.5001 18.3423 37.275 18.3423 36.7266V29.6297C18.3423 29.1813 18.7923 28.8547 19.2048 28.8547H22.0657C27.7751 28.8547 27.6501 37.5001 22.1782 37.5001H19.2048ZM19.9923 30.3797V35.9766H22.0657C25.4392 35.9766 25.5892 30.3797 22.0657 30.3797H19.9923Z"
            fill="white"
          />
          <path
            d="M29.6749 30.4796V32.4655H32.8608C33.3108 32.4655 33.7608 32.9155 33.7608 33.3515C33.7608 33.764 33.3108 34.1015 32.8608 34.1015H29.6749V36.7249C29.6749 37.1624 29.364 37.4983 28.9265 37.4983C28.3765 37.4983 28.0405 37.1624 28.0405 36.7249V29.628C28.0405 29.1796 28.378 28.853 28.9265 28.853H33.3124C33.8624 28.853 34.1874 29.1796 34.1874 29.628C34.1874 30.028 33.8624 30.478 33.3124 30.478H29.6749V30.4796Z"
            fill="white"
          />
          <path
            d="M39.0625 42.1875H9.375V43.75H39.0625C39.9219 43.75 40.625 43.0469 40.625 42.1875V40.625C40.625 41.4844 39.9219 42.1875 39.0625 42.1875Z"
            fill="#CAD1D8"
          />
        </svg>
      </IconWrapper>
    );
  }
  if (mimeType === 'image/png') {
    return (
      <IconWrapper>
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.5 0C10.7812 0 9.375 1.40625 9.375 3.125V46.875C9.375 48.5938 10.7812 50 12.5 50H43.75C45.4688 50 46.875 48.5938 46.875 46.875V12.5L34.375 0H12.5Z"
            fill="#E2E5E7"
          />
          <path
            d="M37.5 12.5H46.875L34.375 0V9.375C34.375 11.0938 35.7812 12.5 37.5 12.5Z"
            fill="#B0B7BD"
          />
          <path
            d="M46.875 21.875L37.5 12.5H46.875V21.875Z"
            fill="#CAD1D8"
          />
          <path
            d="M40.625 40.625C40.625 41.4844 39.9219 42.1875 39.0625 42.1875H4.6875C3.82812 42.1875 3.125 41.4844 3.125 40.625V25C3.125 24.1406 3.82812 23.4375 4.6875 23.4375H39.0625C39.9219 23.4375 40.625 24.1406 40.625 25V40.625Z"
            fill="#A066AA"
          />
          <path
            d="M9.06396 29.6048C9.06396 29.1923 9.3874 28.7407 9.9124 28.7407H12.7999C14.4233 28.7407 15.8858 29.8282 15.8858 31.9142C15.8858 33.8892 14.4233 34.9876 12.7999 34.9876H10.7108V36.6376C10.7108 37.1892 10.364 37.5001 9.9124 37.5001C9.4999 37.5001 9.06396 37.1892 9.06396 36.6376V29.6048ZM10.7108 30.3157V33.4267H12.7983C13.6343 33.4267 14.2968 32.6892 14.2968 31.9142C14.2968 31.0392 13.6343 30.3157 12.7983 30.3157H10.7108Z"
            fill="white"
          />
          <path
            d="M17.4781 29.7298C17.4781 29.2782 17.5781 28.8423 18.2281 28.8423C18.6766 28.8423 18.7781 28.9548 19.1141 29.2782L23.2484 34.4517V29.6048C23.2484 29.1923 23.6094 28.7407 24.0359 28.7407C24.4859 28.7407 24.9219 29.1923 24.9219 29.6048V36.6376C24.9219 37.1892 24.5844 37.3985 24.2594 37.5001C23.8234 37.5001 23.6094 37.4001 23.2484 37.0642L19.1141 31.8157V36.6392C19.1141 37.1907 18.7766 37.5017 18.3266 37.5017C17.8766 37.5017 17.4766 37.1907 17.4766 36.6392V29.7298H17.4781Z"
            fill="white"
          />
          <path
            d="M34.3201 36.5392C33.4326 37.2751 32.3451 37.5892 31.2467 37.5892C28.6217 37.5892 26.7607 36.0892 26.7607 33.1157C26.7607 30.5923 28.7232 28.6313 31.3576 28.6313C32.3451 28.6313 33.4311 28.9688 34.2061 29.7313C34.9686 30.4798 33.8686 31.5923 33.1201 30.9313C32.6576 30.4798 32.0076 30.1438 31.3576 30.1438C29.8467 30.1438 28.3857 31.3548 28.3857 33.1157C28.3857 34.9657 29.6092 36.0892 31.2467 36.0892C32.0076 36.0892 32.6576 35.8642 33.1201 35.5267V33.9923H31.2467C30.1342 33.9923 30.2467 32.4657 31.2467 32.4657H33.7451C34.2076 32.4657 34.6311 32.8173 34.6311 33.2048V35.8657C34.6311 36.0892 34.5326 36.3001 34.3201 36.5392Z"
            fill="white"
          />
          <path
            d="M39.0625 42.1875H9.375V43.75H39.0625C39.9219 43.75 40.625 43.0469 40.625 42.1875V40.625C40.625 41.4844 39.9219 42.1875 39.0625 42.1875Z"
            fill="#CAD1D8"
          />
        </svg>
      </IconWrapper>
    );
  }
  if (mimeType === 'image/jpeg') {
    return (
      <IconWrapper>
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.5 0C10.7812 0 9.375 1.40625 9.375 3.125V46.875C9.375 48.5938 10.7812 50 12.5 50H43.75C45.4688 50 46.875 48.5938 46.875 46.875V12.5L34.375 0H12.5Z"
            fill="#E2E5E7"
          />
          <path
            d="M37.5 12.5H46.875L34.375 0V9.375C34.375 11.0938 35.7812 12.5 37.5 12.5Z"
            fill="#B0B7BD"
          />
          <path
            d="M46.875 21.875L37.5 12.5H46.875V21.875Z"
            fill="#CAD1D8"
          />
          <path
            d="M40.625 40.625C40.625 41.4844 39.9219 42.1875 39.0625 42.1875H4.6875C3.82812 42.1875 3.125 41.4844 3.125 40.625V25C3.125 24.1406 3.82812 23.4375 4.6875 23.4375H39.0625C39.9219 23.4375 40.625 24.1406 40.625 25V40.625Z"
            fill="#50BEE8"
          />
          <path
            d="M13.8642 29.6049C13.8642 28.5549 15.5142 28.5549 15.5142 29.6049V34.5393C15.5142 36.5018 14.5767 37.6893 12.4158 37.6893C11.3533 37.6893 10.4673 37.4002 9.69233 36.4018C9.05483 35.6393 10.2548 34.5408 10.9048 35.3393C11.4298 35.9893 11.9923 36.1393 12.5408 36.1143C13.2392 36.0893 13.8533 35.7752 13.8658 34.5393V29.6049H13.8642Z"
            fill="white"
          />
          <path
            d="M17.7095 29.6047C17.7095 29.1922 18.0345 28.7422 18.5595 28.7422H21.4454C23.0704 28.7422 24.5329 29.8297 24.5329 31.9141C24.5329 33.8891 23.0704 34.9891 21.4454 34.9891H19.3595V36.6391C19.3595 37.1891 19.0095 37.5 18.5595 37.5C18.147 37.5 17.7095 37.1891 17.7095 36.6391V29.6047ZM19.3595 30.3156V33.4281H21.4454C22.2829 33.4281 22.9454 32.6891 22.9454 31.9141C22.9454 31.0406 22.2829 30.3156 21.4454 30.3156H19.3595Z"
            fill="white"
          />
          <path
            d="M33.4549 36.5391C32.5674 37.2766 31.4799 37.5891 30.3814 37.5891C27.7564 37.5891 25.8955 36.0906 25.8955 33.1156C25.8955 30.5937 27.858 28.6328 30.4924 28.6328C31.4799 28.6328 32.5658 28.9687 33.3408 29.7312C34.1018 30.4797 33.0033 31.5922 32.2549 30.9312C31.7924 30.4812 31.1424 30.1437 30.4924 30.1437C28.9814 30.1437 27.5205 31.3547 27.5205 33.1156C27.5205 34.9656 28.7439 36.0906 30.3814 36.0906C31.1424 36.0906 31.7924 35.8641 32.2549 35.5281V33.9922H30.3814C29.2689 33.9922 29.3814 32.4672 30.3814 32.4672H32.8799C33.3424 32.4672 33.7658 32.8172 33.7658 33.2047V35.8656C33.7658 36.0906 33.6674 36.3 33.4549 36.5391Z"
            fill="white"
          />
          <path
            d="M39.0625 42.1875H9.375V43.75H39.0625C39.9219 43.75 40.625 43.0469 40.625 42.1875V40.625C40.625 41.4844 39.9219 42.1875 39.0625 42.1875Z"
            fill="#CAD1D8"
          />
        </svg>
      </IconWrapper>
    );
  }
  if (mimeType === 'image/webp') {
    return (
      <IconWrapper>
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.5 0C10.7812 0 9.375 1.40625 9.375 3.125V46.875C9.375 48.5938 10.7812 50 12.5 50H43.75C45.4688 50 46.875 48.5938 46.875 46.875V12.5L34.375 0H12.5Z"
            fill="#E2E5E7"
          />
          <path
            d="M37.5 12.5H46.875L34.375 0V9.375C34.375 11.0938 35.7812 12.5 37.5 12.5Z"
            fill="#B0B7BD"
          />
          <path
            d="M46.875 21.875L37.5 12.5H46.875V21.875Z"
            fill="#CAD1D8"
          />
          <path
            d="M40.625 40.625C40.625 41.4844 39.9219 42.1875 39.0625 42.1875H4.6875C3.82812 42.1875 3.125 41.4844 3.125 40.625V25C3.125 24.1406 3.82812 23.4375 4.6875 23.4375H39.0625C39.9219 23.4375 40.625 24.1406 40.625 25V40.625Z"
            fill="#84BD5A"
          />
          <path
            d="M39.0625 42.1875H9.375V43.75H39.0625C39.9219 43.75 40.625 43.0469 40.625 42.1875V40.625C40.625 41.4844 39.9219 42.1875 39.0625 42.1875Z"
            fill="#CAD1D8"
          />
          <path
            d="M8.17463 37.7759C7.96005 37.7759 7.78838 37.7545 7.65963 37.7115C7.53946 37.66 7.4665 37.5828 7.44075 37.4798L5.252 29.2269C5.24342 29.184 5.23484 29.1454 5.22625 29.111C5.21767 29.0681 5.21338 29.0295 5.21338 28.9952C5.21338 28.9007 5.26488 28.8321 5.36788 28.7892C5.47088 28.7377 5.63396 28.7119 5.85713 28.7119H6.42363C6.61246 28.7119 6.77125 28.7248 6.9 28.7505C7.03734 28.7763 7.12317 28.875 7.1575 29.0467L8.4965 35.7545H8.548L10.093 29.0982C10.1359 28.9351 10.2303 28.8321 10.3763 28.7892C10.5222 28.7377 10.6895 28.7119 10.8784 28.7119H11.2389C11.4363 28.7119 11.6123 28.7377 11.7668 28.7892C11.9213 28.8407 12.0157 28.9522 12.05 29.1239L13.5564 35.7545H13.6079L14.9726 29.0467C14.9984 28.9179 15.067 28.8321 15.1786 28.7892C15.2902 28.7377 15.4233 28.7119 15.5778 28.7119H16.0928C16.3674 28.7119 16.5648 28.7377 16.685 28.7892C16.8138 28.8321 16.8781 28.9007 16.8781 28.9952C16.8781 29.0295 16.8738 29.0681 16.8653 29.111C16.8567 29.1454 16.8438 29.184 16.8266 29.2269L14.6379 37.4798C14.6121 37.5828 14.5349 37.66 14.4061 37.7115C14.286 37.7545 14.1186 37.7759 13.904 37.7759H13.2345C13.0199 37.7759 12.8483 37.7545 12.7195 37.7115C12.5908 37.66 12.5135 37.5828 12.4878 37.4798L11.0715 31.3384H11.02L9.59088 37.4798C9.56513 37.5828 9.48788 37.66 9.35913 37.7115C9.23038 37.7545 9.05871 37.7759 8.84413 37.7759H8.17463Z"
            fill="white"
          />
          <path
            d="M18.2191 37.7502C17.9016 37.7502 17.7428 37.5785 17.7428 37.2352V29.2527C17.7428 28.9093 17.9016 28.7377 18.2191 28.7377H22.8155C23.073 28.7377 23.2018 28.9522 23.2018 29.3814V29.7805C23.2018 30.2097 23.073 30.4243 22.8155 30.4243H19.7384V32.2912H22.4808C22.7297 32.2912 22.8541 32.5057 22.8541 32.9349V33.334C22.8541 33.7632 22.7297 33.9778 22.4808 33.9778H19.7384V36.0635H22.8284C23.0859 36.0635 23.2146 36.2781 23.2146 36.7073V37.1064C23.2146 37.5356 23.0859 37.7502 22.8284 37.7502H18.2191Z"
            fill="white"
          />
          <path
            d="M25.2476 37.7502C24.93 37.7502 24.7712 37.5785 24.7712 37.2352V29.2527C24.7712 28.9093 24.93 28.7377 25.2476 28.7377H27.8355C28.565 28.7377 29.1487 28.8364 29.5865 29.0338C30.0328 29.2226 30.359 29.4887 30.565 29.832C30.771 30.1668 30.874 30.5616 30.874 31.0165C30.874 31.317 30.8096 31.6002 30.6808 31.8663C30.5607 32.1238 30.3933 32.3512 30.1787 32.5487C29.9727 32.7375 29.741 32.8791 29.4835 32.9735V33.025C29.8268 33.0937 30.1272 33.2353 30.3847 33.4499C30.6508 33.6559 30.8568 33.9048 31.0027 34.1967C31.1572 34.4885 31.2345 34.8018 31.2345 35.1365C31.2345 35.6859 31.1143 36.158 30.874 36.5528C30.6422 36.939 30.2903 37.2352 29.8182 37.4412C29.3461 37.6472 28.7453 37.7502 28.0157 37.7502H25.2476ZM26.7668 36.0635H28.0801C28.432 36.0635 28.7067 35.9734 28.9041 35.7932C29.1015 35.6129 29.2002 35.3554 29.2002 35.0207C29.2002 34.6859 29.0843 34.437 28.8526 34.2739C28.6294 34.1022 28.3032 34.0164 27.8741 34.0164H26.7668V36.0635ZM26.7668 32.3427H27.7067C28.0758 32.3427 28.3547 32.2482 28.5436 32.0594C28.741 31.8706 28.8397 31.6431 28.8397 31.377C28.8397 31.0595 28.7496 30.8234 28.5693 30.6689C28.3891 30.5058 28.1101 30.4243 27.7325 30.4243H26.7668V32.3427Z"
            fill="white"
          />
          <path
            d="M33.1757 37.7759C32.9096 37.7759 32.7122 37.7416 32.5834 37.6729C32.4632 37.5957 32.4032 37.4884 32.4032 37.351V29.2527C32.4032 28.9093 32.562 28.7377 32.8795 28.7377H35.5318C36.579 28.7377 37.3643 28.9737 37.8879 29.4458C38.4201 29.9179 38.6862 30.626 38.6862 31.5702C38.6862 32.5057 38.4201 33.2139 37.8879 33.6945C37.3643 34.1666 36.579 34.4027 35.5318 34.4027H34.3988V37.351C34.3988 37.4884 34.3387 37.5957 34.2185 37.6729C34.0984 37.7416 33.901 37.7759 33.6263 37.7759H33.1757ZM34.3988 32.716H35.5318C35.9266 32.716 36.2099 32.6259 36.3815 32.4457C36.5618 32.2654 36.6519 31.9736 36.6519 31.5702C36.6519 31.1667 36.5618 30.8749 36.3815 30.6947C36.2099 30.5144 35.9266 30.4243 35.5318 30.4243H34.3988V32.716Z"
            fill="white"
          />
        </svg>
      </IconWrapper>
    );
  }

  return assertNever(`Invalid attachment MIME-type "${mimeType}"`);
});
